<template>
  <v-container fluid>
    <v-card class="mb-6">
      <v-toolbar color="secondary" dark shaped>
        <h3 style="text-transform: uppercase; font-weight: 400">
          {{ $route.name }}
        </h3>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <v-row class="mb-6">
          <v-col cols="12" sm="3" md="3">
            <Date
              @dateValue="[(filter.date = $event)]"
              label="Mês e Ano"
              type="month"
            />
          </v-col>
          <v-col cols="12" sm="9" md="9">
            <v-autocomplete
              :items="prefectures"
              label="Prefeitura:"
              v-model="filter.prefecture_id"
              item-value="prefecture_id"
              item-text="prefecture_social_name"
            />
          </v-col>
        </v-row>
        <v-footer absolute rounded>
          <v-spacer />
          <v-btn
            color="secondary"
            class="mr-2"
            text
            @click="loadSituacao"
            :disabled="isButtonDisabled"
          >
            FILTRAR
          </v-btn>
        </v-footer>
      </v-card-text>
    </v-card>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{ $route.name }}</h3>
        <v-spacer />
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              dark
              v-bind="attrs"
              v-on="on"
              to="/vehicles-manager/situacao/create"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Adicionar</span>
        </v-tooltip>
        <v-footer absolute color="primary" dark v-if="showSearch">
          <v-text-field
            class="search-field"
            v-model="search"
            color="#fff"
            placeholder="pesquisar"
            prepend-inner-icon="mdi-magnify"
            append-outer-icon="mdi-close"
            @click:append-outer="showSearch = !showSearch"
          />
        </v-footer>
      </v-toolbar>

      <v-card-actions>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :loading="loader"
          loading-text="CARREGANDO..."
          class="elevation-0 maxPage"
        >
          <template v-slot:item.situacao="{ item }">
            <span>
              {{
                item.situacao == 1
                  ? "Em Uso"
                  : item.situacao == 2
                  ? "Em Manutenção"
                  : "Baixada"
              }}
            </span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteItem(item.id)"
                  color="error"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-actions>
    </v-card>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Date from "@/components/InputDate.vue";
export default {
  components: { Date },
  props: ["id"],
  data() {
    return {
      search: "",
      loader: true,
      showSearch: false,
      data: [],
      prefectures: [],
      filter: {
        prefecture_id: null,
        date: null,
      },
      snack: {
        show: false,
        message: "",
        color: "",
      },
      headers: [
        { text: "Veículo/Máquina", value: "veiculo", sortable: false },
        { text: "Data", value: "data", sortable: false },
        { text: "Situação", value: "situacao", sortable: false },
        { text: "Ações", align: "right", value: "action", sortable: false },
      ],
    };
  },
  created() {
    this.initialize();
  },
  computed: {
    isButtonDisabled() {
      return !(this.filter.prefecture_id && this.filter.date);
    },
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http.get("/prefectures").then((r) => {
        this.prefectures = r.data;
        this.loader = false;
        this.$store.dispatch("setLoader", this.loader);
      });
    },
    loadSituacao() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(
          `/vehicles/situacao/all/${
            this.filter.prefecture_id
          }/${this.filter.date.substring(0, 4)}/${this.filter.date.substring(
            5
          )}`
        )
        .then((r) => {
          this.data = r.data;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    deleteItem(id) {
      let c = confirm("Deseja excluir o registro?");
      if (c) {
        this.$store.dispatch("setLoader", true);
        this.$http
          .delete(`/vehicles/situacao/${id}`)
          .then(() => {
            this.snack.show = true;
            this.snack.message = "Excluido com sucesso!";
            this.snack.color = "success";
            this.loadSituacao();
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style scoped>
.title {
  text-transform: uppercase;
  font-weight: 400;
}
.maxPage {
  width: 100%;
}
.search-field {
  margin-top: 10px;
}
</style>
